<template>
  <div id="mainPanel">
    <div class="btn">
      <!-- <button @click="close()">Close</button> -->
      <div
        :class="resetEnabled && !resetWait ? 'btnEnabled' : 'btnDisabled'"
        @click="reset"
        title="Reset Audio/Video"
      >
        <img :src="resetEnabled ? resetImg : resetGreyImg" />
      </div>
      <div
        :class="reportEnabled ? 'btnEnabled' : 'btnDisabled'"
        @click="report"
        title="Report Issues"
      >
        <img :src="reportEnabled ? reportImg : reportGreyImg" />
      </div>
      <div class="btnEnabled" @click="close()">
        <img :src="closeImg" />
      </div>
    </div>
    <div class="deviceList">
      <div>
        <div class="title">Audio input source:</div>
        <div>
          <select
            @change="inputChange"
            v-model="microphoneSelected"
            class="deviceselect"
          >
            <option
              v-for="(device, i) in inputDevices"
              :value="device.value"
              :key="i"
            >
              {{ device.label }}
            </option>
          </select>
        </div>
      </div>

      <div>
        <div class="title">Audio output source:</div>
        <div>
          <select
            @change="outputChange"
            class="deviceselect spakerSelect"
            v-model="speakerSelected"
          >
            <option
              v-for="(device, i) in outputDevices"
              :value="device.value"
              :key="i"
            >
              {{ device.label }}
            </option>
          </select>
        </div>
      </div>

      <div>
        <div class="title">Video input source:</div>
        <div>
          <select
            @change="videoInputChange"
            v-model="cameraSelected"
            class="deviceselect"
          >
            <option
              v-for="(device, i) in cameraDevices"
              :value="device.value"
              :key="i"
            >
              {{ device.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "../eventBus";

export default {
  components: { eventBus },
  name: "Device",
  props: {
    isShowDevice: { type: Boolean, default: false },
    resetEnabled: { type: Boolean, default: false },
  },
  data() {
    return {
      debugMode: process.env.VUE_APP_DEBUG,
      inputDevices: [],
      outputDevices: [],
      cameraDevices: [],
      inputSelect: "",
      videoStatus: "Disconnect",
      closeImg: require("@/assets/close.png"),
      reportImg: require("@/assets/Images/report.png"),
      reportGreyImg: require("@/assets/Images/reportGrey.png"),
      resetImg: require("@/assets/Images/reset.png"),
      resetGreyImg: require("@/assets/Images/resetGrey.png"),
      resetWait: false,
      reportEnabled: true,
      cameraSelected: "",
      microphoneSelected: "",
      speakerSelected: "",
    };
  },
  computed: {
    micPermission() {
      return this.$store.state.micPermission;
    },
    camPermission() {
      return this.$store.state.camPermission;
    },
  },
  watch: {
    micPermission(val) {
      this.initDevices();
    },
    camPermission(val) {
      this.initDevices();
    },
  },
  created: function () {
    this.updateDeviceList();
  },
  mounted: function () {
    this.initDevices();
    navigator.mediaDevices.ondevicechange = (e) => {
      this.initDevices();
    };
  },
  methods: {
    initDevices() {
      navigator.mediaDevices
        .enumerateDevices()
        .then(this.gotDevices)
        // .then(this.inputChange)
        .catch(this.handleError);
    },
    gotDevices(deviceInfos) {
      this.inputDevices = [];
      this.outputDevices = [];
      this.cameraDevices = [];
      // Handles being called several times to update labels. Preserve values.
      let micCount = 1;
      let hasDeviceId = false;
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        // console.log(deviceInfo);
        if (deviceInfo.kind === "audioinput") {
          if (deviceInfo.deviceId == this.getLocalStorageItem("microphoneId")) {
            hasDeviceId = true;
            this.inputSelect = deviceInfo.label;
            eventBus.$emit("updateInputDeviceId", deviceInfo.deviceId);
          }
          this.inputDevices.push({
            label: deviceInfo.label || `microphone ${micCount}`,
            value: deviceInfo.deviceId,
          });
          micCount++;
        }
      }
      this.microphoneSelected = hasDeviceId
        ? this.getLocalStorageItem("microphoneId")
        : this.inputDevices[0].value;

      let speakerCount = 1;
      hasDeviceId = false;
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        if (deviceInfo.kind === "audiooutput") {
          if (deviceInfo.deviceId == this.getLocalStorageItem("speakerId")) {
            hasDeviceId = true;
          }
          this.outputDevices.push({
            label: deviceInfo.label || `speaker ${speakerCount}`,
            value: deviceInfo.deviceId,
          });
          speakerCount++;
        }
      }
      let firstSpeakerId =
        this.outputDevices.length == 0 ? "" : this.outputDevices[0].value;
      this.speakerSelected = hasDeviceId
        ? this.getLocalStorageItem("speakerId")
        : firstSpeakerId;
      //set spaker
      this.attachSinkId(this.speakerSelected);

      let cameraCount = 1;
      hasDeviceId = false;
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        if (deviceInfo.kind === "videoinput") {
          if (deviceInfo.deviceId == this.getLocalStorageItem("cameraId")) {
            hasDeviceId = true;
            eventBus.$emit("updateVideoInputDeviceId", deviceInfo.deviceId);
          }
          this.cameraDevices.push({
            label: deviceInfo.label || `camera ${cameraCount}`,
            value: deviceInfo.deviceId,
          });
          cameraCount++;
        }
      }
      this.cameraSelected = hasDeviceId
        ? this.getLocalStorageItem("cameraId")
        : this.cameraDevices[0].value;
    },
    inputChange(e) {
      console.log(e.target.value);
      localStorage.setItem("microphoneId", e.target.value);
      eventBus.$emit("updateInputDeviceId", e.target.value);
    },
    videoInputChange(e) {
      console.log(e.target.value);
      localStorage.setItem("cameraId", e.target.value);
      eventBus.$emit("updateVideoInputDeviceId", e.target.value);
    },
    handleError(error) {
      console.log(
        "navigator.MediaDevices.getUserMedia error: ",
        error.message,
        error.name
      );
    },
    gotStream(stream) {
      window.stream = stream;
    },
    outputChange: function (event) {
      const deviceId = event.target.value;
      localStorage.setItem("speakerId", deviceId);
      const outputSelector = event.target;
      // FIXME: Make the media element lookup dynamic.
      this.attachSinkId(deviceId);
    },
    attachSinkId: function (sinkId) {
      let audios = document.querySelectorAll("audio");
      for (let i = 0; i < audios.length; i++) {
        if (typeof audios[i].sinkId !== "undefined") {
          audios[i]
            .setSinkId(sinkId)
            .then(() => {
              console.log(`Success, audio output device attached: ${sinkId}`);
            })
            .catch((error) => {
              let errorMessage = error;
              if (error.name === "SecurityError") {
                errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
              }
              console.error(errorMessage);
              // Jump back to first output device in the list as it's the default.
            });
        } else {
          console.warn("Browser does not support output device selection.");
        }
      }

      let videos = document.querySelectorAll("video");
      for (let i = 0; i < videos.length; i++) {
        if (typeof videos[i].sinkId !== "undefined") {
          videos[i]
            .setSinkId(sinkId)
            .then(() => {
              console.log(`Success, audio output device attached: ${sinkId}`);
            })
            .catch((error) => {
              let errorMessage = error;
              if (error.name === "SecurityError") {
                errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
              }
              console.error(errorMessage);
              // Jump back to first output device in the list as it's the default.
            });
        } else {
          console.warn("Browser does not support output device selection.");
        }
      }
    },
    updateSinkId: function () {
      this.attachSinkId(this.speakerSelected);
    },
    updateValue: function (valueName, val) {
      this.$emit("update:" + valueName, val);
    },
    close: function () {
      this.$emit("closebox", true);
    },
    updateDeviceList: function () {
      eventBus.$on("updatePermission", (val) => {
        navigator.mediaDevices
          .enumerateDevices()
          .then(this.gotDevices)
          .catch(this.handleError);
      });
    },
    reset: function () {
      if (this.resetWait) return;
      console.log("reset clicked");
      this.$parent.resetConnect();
      this.resetWait = true;
      setTimeout(() => {
        this.resetWait = false;
      }, 5000);
    },
    report: function () {
      if (!this.reportEnabled) return;
      console.log("report clicked");
      this.$parent.report();
    },
    getLocalStorageItem: function (key) {
      return localStorage.getItem(key) == null ? "" : localStorage.getItem(key);
    },
  },
  beforeDestroy: function () {
    this.$emit("closebox", true);
  },
};
</script>

<style scoped>
#mainPanel {
  /* position: absolute;
  right: 1rem;
  top: 1rem; */
  background-color: #141414;
  border: 2px solid #ffffff;
  border-radius: 1rem;
}
.title {
  color: #ffffff;
  font-size: 1rem;
  font-weight: bold;
}
.deviceselect {
  height: 2rem;
  border: 0;
  font-weight: 400;
  border-radius: 5px;
  width: 100%;
}
.btn {
  padding: 0.4rem;
  display: flex;
  justify-content: flex-end;
}
.btn > div {
  cursor: pointer;
  border-radius: 5px;
  margin: 2px;
}
.btn > div > img {
  display: block;
  margin: 0 auto;
}
.btnEnabled:hover {
  background-color: #484848;
}
.btnDisabled {
  background-color: #eee;
}
.deviceList {
  padding: 0 1rem 1rem;
}
.deviceList > div {
  padding: 0.3rem 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Device.vue